/**
 * Helper function for RxJS subscriptions that don't require any action to be taken.
 */
export const NOTHING_TO_DO = (): void => {
};
